import { cn } from '@Pages/pageRuntime/lib/utils';
import * as React from 'react';

import { type BaseInputProps, inputClassNames } from './inputBase';

export type NonFileInputTypes =
  | 'text'
  | 'email'
  | 'password'
  | 'number'
  | 'date'
  | 'time'
  | 'datetime-local'
  | 'url'
  | 'search'
  | 'tel'
  | 'color'
  | 'hidden'
  | 'range'
  | 'textarea';

export type InputProps = BaseInputProps & {
  type?: NonFileInputTypes;
  onChange?: (value: string) => void;
};
const Input = ({
  className,
  type = 'text',
  onChange,
  ref,
  ...rest
}: InputProps & { ref?: React.Ref<HTMLInputElement> }) => (
  <input
    ref={ref}
    type={type}
    className={cn(inputClassNames, className)}
    onChange={onChange ? (e) => onChange(e.target.value) : undefined}
    {...rest}
  />
);
Input.displayName = 'Input';

export { Input };
